import { api } from './client';
import type { AuditLog, Page } from '../types';

export interface AuditQuery {
  storeId?: number | null;
  page?: number;
  size?: number;
}

export const auditApi = {
  list: (query: AuditQuery = {}) =>
    api
      .get<Page<AuditLog>>('/audit-logs', {
        params: {
          storeId: query.storeId ?? undefined,
          page: query.page ?? 0,
          size: query.size ?? 20,
        },
      })
      .then((r) => r.data),
};
